import {animate, state, style, transition, trigger} from '@angular/animations';
import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-youtube-video-popup',
  templateUrl: './youtube-video-popup.component.html',
  styleUrls: ['./youtube-video-popup.component.scss'],
  animations: [
    trigger('openClosePopup', [
      state('open', style({display: 'flex', opacity: 1})),
      state('closed', style({display: 'none', opacity: 0})),
      transition('open => closed', [
        animate('700ms cubic-bezier(0.68, -0.6, 0.32, 1.6)')
      ]),
      transition('closed => open', [
        style({display: 'flex', opacity: 0}),
        animate('700ms cubic-bezier(0.68, -0.6, 0.32, 1.6)')
      ])
    ])
  ]
})
export class YoutubeVideoPopupComponent implements OnInit {
  embeddedLink: SafeResourceUrl;
  private _src: string;

  @Input() set src(value: string) {
    this._src = value;
    this.setYouTubeLink();
  }

  get src() {
    return this._src;
  }

  @Input() visible = false;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  open(): void {
    this.visible = true;
  }

  close(): void {
    this.visible = false;
  }

  setYouTubeLink(): void {
    this.embeddedLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.src);
  }

}
